module.exports = __webpack_public_path__ + "static/media/no-reportsV2.b49b0680.svg";